import React, { useEffect, useState } from 'react';

const VendorForm = ({ mode, vendor, onClose, onSave, userID }) => {
  const [form, setForm] = useState({
    userid: userID || "",
    vendorName: "",
    vendorType: "",
    vendorCategory: "",
    vendorAddress: "",
    gst: "",
    mobile: "",
    state: "",
    city: "",
    vendorId: null,
  });

  useEffect(() => {
    if (mode === "edit" && vendor) {
      setForm({
        userid: userID || vendor.userid || "",
        vendorId: vendor.id || vendor.vendorId,
        vendorName: vendor.vendorName || "",
        vendorType: vendor.vendorType || "",
        vendorCategory: vendor.vendorCategory || "",
        vendorAddress: vendor.vendorAddress || "",
        gst: vendor.gst || "",
        mobile: vendor.mobile || "",
        state: vendor.state || "",
        city: vendor.city || "",
      });
    } else {
      setForm({
        userid: userID || "",
        vendorName: "",
        vendorType: "",
        vendorCategory: "",
        vendorAddress: "",
        gst: "",
        mobile: "",
        state: "",
        city: "",
    
      });
    }
  }, [mode, vendor, userID]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form); // parent will call API with this payload
    onClose();
  };
  const VENDOR_TYPES = [
  "Retailers",
  "Service providers",
  "Manufacturer",
  "Wholesaler",
  "Wholesalers or distributors",
  "Independent craftspeople",
  "B2c vendors",
  "Independent Vendor",
  "B2b",
  "Service vendors",
  "Retail vendors",
];

const PRODUCT_CATEGORIES = [
  "Electronics",
  "Dairy",
  "Toys",
  "Grocery",
  "Fresh Produce",
  "Meat & Seafood",
  "Bakery",
  "Beverages",
  "Frozen",
  "Household",
  "Personal Care",
  "Stationery",
  "Apparel",
  "Hardware",
  "Automotive",
  "Pharmacy",
  "Beauty",
  "Baby",
  "Pet Care",
  "Other",
];


  return (
    <div className="vendor-form-container">
      <div className="vendor-form-header">
        <h4>{mode === "add" ? "Add Vendor" : "Edit Vendor"}</h4>
        <button onClick={onClose} className="vendor-btn-close">
          ×
        </button>
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="vendorName"
          className="vendor-form-control"
          placeholder="Vendor Name"
          value={form.vendorName}
          onChange={handleChange}
          required
        />
    <select
  name="vendorType"
  className="vendor-form-control"
  value={form.vendorType}
  onChange={handleChange}
  required
>
  <option value="">Select Vendor Type</option>
  {VENDOR_TYPES.map((t) => (
    <option key={t} value={t}>{t}</option>
  ))}
</select>

<select
  name="vendorCategory"
  className="vendor-form-control"
  value={form.vendorCategory}
  onChange={handleChange}
  required
>
  <option value="">Select Product Category</option>
  {PRODUCT_CATEGORIES.map((c) => (
    <option key={c} value={c}>{c}</option>
  ))}
</select>

        <textarea
          name="vendorAddress"
          className="vendor-form-control"
          placeholder="Vendor Address"
          value={form.vendorAddress}
          onChange={handleChange}
          rows={3}
          required
        ></textarea>

        <input
          type="text"
          name="gst"
          className="vendor-form-control"
          placeholder="GST Number"
          value={form.gst}
          onChange={handleChange}
        />
        <input
          type="tel"
          name="mobile"
          className="vendor-form-control"
          placeholder="Mobile Number"
          value={form.mobile}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="state"
          className="vendor-form-control"
          placeholder="State"
          value={form.state}
          onChange={handleChange}
        />
        <input
          type="text"
          name="city"
          className="vendor-form-control"
          placeholder="City"
          value={form.city}
          onChange={handleChange}
        />

        <div className="vendor-form-actions">
          <button type="submit" className="vendor-btn-save">
            Save
          </button>
          <button
            type="button"
            className="vendor-btn-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default VendorForm;
